import { IUnitedSubSections } from 'constants/businessToolSections';
import { FOR_INVESTORS_SECTIONS, IForInvestorsSections } from 'constants/businessToolSections/forInvestors';

import { BusinessOperations } from './BusinessOperations';
import { CompanyAndProject } from './CompanyAndProject';
import { ExecutiveSummary } from './ExecutiveSummary';
import { FinancialPlan } from './FinancialPlan';
import { ManagementAndOrganization } from './ManagementAndOrganization';
import { MarketAnalysis } from './MarketAnalysis';
import { MarketingAndSales } from './MarketingAndSales';
import { Overview } from './Overview';
import { RaisingAndAllocationFunds } from './RaisingAndAllocationFunds';

export type IForInvestorFormSubSections = {
  [key in IUnitedSubSections]?: React.ComponentType;
};

export type IForInvestorFormSections = {
  [key in IForInvestorsSections]: React.ComponentType;
};

export const forInvestorSections: IForInvestorFormSections = {
  [FOR_INVESTORS_SECTIONS.OVERVIEW]: Overview,
  [FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY]: ExecutiveSummary,
  [FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT]: CompanyAndProject,
  [FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS]: MarketAnalysis,
  [FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES]: MarketingAndSales,
  [FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS]: BusinessOperations,
  [FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: ManagementAndOrganization,
  [FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: RaisingAndAllocationFunds,
  [FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN]: FinancialPlan,
};
